import React from "react"

export const SelectArray = ({ name, value, onChange, data, propid, propdescripcion }) => {
    if (data === undefined || data === null || data.length === 0) {
        <select name={name} value={value} onChange={onChange}>
            <option value='0'>Seleccionar...</option>
        </select>
    }
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='0'>Seleccionar...</option>
            {
                data.map(item => (
                    <option value={item[propid]}>{item[propdescripcion]}</option>
                ))
            }
        </select>
    )
}
